import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { AppBar, createStyles, DialogTitle, Theme, Toolbar, Typography, withStyles, WithStyles } from '@material-ui/core';
import { SystemsData } from './SystemsContext';
import { Utilities } from '../general/utilities';
import { DeltaXMLColors } from './styling/DeltaColors';

const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      alignItems: "left",
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
  });

export interface ReturnLicenseProps extends WithStyles<typeof styles> {
  dialogOpen: boolean;
  systemData: SystemsData;
  handleDeactivateCancel: () => void;
  handleDeactivateConfirm: () => void;
}

function ReturnLicenseDialog(props: ReturnLicenseProps) {
  const { classes, dialogOpen, systemData, handleDeactivateCancel, handleDeactivateConfirm } = props;
  let dialogText = '';
  let remainingReturns: number | undefined;
  let allowReturn = false;
  let fetchingData = true;

  if (systemData.returnCount !== undefined) {
    fetchingData = false;
    remainingReturns = systemData.returnCountLimit - systemData.returnCount;
    allowReturn = remainingReturns > 0;
  }

  let warningText = '';
  if (fetchingData) {
    dialogText = 'Fetching license return data...'
  } else if (allowReturn) {
    warningText = remainingReturns === 1 ? `There is 1 return remaining for this system.` : `There are ${remainingReturns} returns remaining for this system.`
    dialogText = 'Reset host data for the license?'
  } else {
    warningText = `This system cannot be returned because the license return limit (${systemData.returnCountLimit}) has been reached. Please contact DeltaXML support if you need an extension to this limit.`
  }


  return (
    <Dialog
      open={dialogOpen}
      onClose={handleDeactivateCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <AppBar className={classes.appBar} position="static">
        <Toolbar>
          <Typography variant="h4" >Return License</Typography>
        </Toolbar>
      </AppBar>
      <br />
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="body1">{warningText}</Typography>
          <Typography variant="body1"><b>{dialogText}</b></Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {allowReturn &&
          <Button onClick={handleDeactivateConfirm} variant="contained" color="primary" autoFocus>
            Confirm
          </Button>}
        <Button onClick={handleDeactivateCancel} variant="contained" color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default withStyles(styles)(ReturnLicenseDialog);